import * as React from 'react';
import { SVGProps } from 'react';
const SvgCheckStroked = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12c0-4.519 3.481-8 8-8s8 3.481 8 8-3.481 8-8 8-8-3.481-8-8Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z"
      fill="current"
    />
    <path
      d="m6.629 12.678 1.452-1.376 2.026 2.139 5.844-5.464 1.376 1.451-7.259 6.879-3.44-3.63Z"
      fill="current"
    />
  </svg>
);
export default SvgCheckStroked;
